import { R3NgModuleMetadata } from "@angular/compiler";
import { Component, Input, OnInit } from "@angular/core";
//import { moduleDef } from "@angular/core/src/view";
import { FormControl } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
// import { NotificationsService } from "angular2-notifications";
// import { ToastrService } from "ngx-toastr";
import { title } from "process";
import { BaseDataService, ConfirmationDialogButtons, ModalService, ModalSize, ModelData, NotificationService, QueryParameter } from "yt-ng-framework";

@Component({
    selector: 'yt-polja-za-velike-lance',
    templateUrl: './polja-za-velike-lance.component.html'
  })
export class PoljaZaVelikeLanceComponent implements OnInit{

    
    constructor(
        protected activeModal: NgbActiveModal,
        protected baseDataService: BaseDataService,
        // protected notificationService: NotificationsService
        protected toastrService: NotificationService,
        protected modalService: ModalService
      )
      {
        
      }

      @Input() Parameters: QueryParameter[];
      initialFormValue: any;
      trebaPrijemnica:boolean=true;

    ngOnInit() {
      
      this.formGroup.patchValue({BrojNarudzbenice: this.Parameters[0].Value});
      this.formGroup.patchValue({DatumNarudzbenice: this.Parameters[1].Value});
      
      // Uključivanje/Isključivanje broja prijemnice
      if (this.Parameters[7].Value==null || this.Parameters[7].Value=='true')
      {
        this.formGroup.patchValue({BrojPrijemnice: this.Parameters[2].Value});
        this.formGroup.patchValue({DatumPrijemnice: this.Parameters[3].Value});
      }
      else
        this.trebaPrijemnica=false;

      this.formGroup.patchValue({ReferencaKupcaNaDrugiDokument: this.Parameters[4].Value});
      //this.formGroup.patchValue({InterniBrojZaRutiranje: this.Parameters[5].Value});
      this.formGroup.patchValue({OdgovornoLiceID: this.Parameters[5].Value});
      if (this.Parameters[6].Value)
        this.formGroup.disable();
      else
        this.formGroup.enable();

        this.initialFormValue = this.formGroup.getRawValue();
    }

    formGroup = new FormGroup({
      BrojNarudzbenice: new FormControl(),
      DatumNarudzbenice: new FormControl(),
      BrojPrijemnice: new FormControl(),
      DatumPrijemnice: new FormControl(),
      ReferencaKupcaNaDrugiDokument: new FormControl(),
      //InterniBrojZaRutiranje: new FormControl(),
      OdgovornoLiceID: new FormControl()
    })

    Save(){
      this.activeModal.close(
        this.formGroup.getRawValue()
      )
      // this.notificationService.info( 'Dodatna polja', 'Uspešno dopisani podaci na tekući dokument.')
      this.toastrService.info( 'Dodatna polja', 'Uspešno dopisani podaci na tekući dokument.');
    }

    Close(){
      const currentValue = this.formGroup.getRawValue();
      const isChanged = JSON.stringify(currentValue) !== JSON.stringify(this.initialFormValue);
    
      if (isChanged) {
        this.modalService.ShowConfirmationDialog(
          "Obaveštenje",
          "Postoje promene u tekućim podacima. Akcijom koju ste pokrenuli promene neće biti sačuvane.",
          "question",
          ConfirmationDialogButtons.ConfirmCancel
        ).result.then((result) => {
          if (result === ConfirmationDialogButtons.ConfirmCancel || result === true) {
            this.activeModal.dismiss();
          }
        }).catch(() => {});
      } else {
        this.activeModal.dismiss();
      }
    }

    ngOnDestroy(): void {
      if (this.formGroup) {
        this.formGroup=null;
      }
    }
}